/**
 * The deploy's sign-in method, read once, for the places that must behave differently when Clerk
 * is off (Akhil, 2026-09-24). `lib/auth.ts` decides it; this is the accessor for non-React code
 * — `frappeSession.ts` and `useMasters.ts` both need it below the component tree.
 */
import { resolveAuthProvider, type AuthProvider } from '../auth'

const provider: AuthProvider = resolveAuthProvider(
  import.meta.env.VITE_BOSUN_AUTH,
  import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
)

export function currentAuthProvider(): AuthProvider {
  return provider
}

export function isFrappeAuth(which: AuthProvider = provider): boolean {
  return which === 'frappe'
}

/**
 * Whether the top bar offers a Sign out button. Under `frappe` always: the session is Frappe's
 * own and `/api/method/logout` ends it, so a password-authenticated person must never be left
 * with no way out. Under `clerk` it takes both halves — who is signed in, and a way to end that
 * session — exactly as before.
 */
export function canSignOut(which: AuthProvider, identity: { email: string } | null, clerkSignOut: (() => Promise<void>) | null): boolean {
  if (which === 'frappe') return true
  return identity !== null && clerkSignOut !== null
}
